import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import sharedContainer from './TipSharedContainer';
import PaymentModalTip from '../components/PaymentModalTip';
import withRouteParameters from './withRouteParameters';
import { setTip } from '../actions';

export default compose(
  withRouteParameters,
  connect(null, { setTip }),
  sharedContainer,
  lifecycle({
    componentDidMount() {
      this.props.setTip(this.props.defaultTip);
    },
    componentWillUnmount() {
      this.props.setTip(0);
    },
  })
)(PaymentModalTip);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentModalTip.js